module.exports = __webpack_public_path__ + "assets/eb93a6edfb81d72d3637ded874c7f8ff.svg";